module.exports = __webpack_public_path__ + "img/00d3e57.svg";